<template>
    <Modal class="justify-space-around absolute">
        <v-card class="result-content d-flex ">

            <img class="logo" style="width: 84px;height: 84px" alt="" src="../../assets/logo.png"/>
            <label v-if="this.providers" class="main-label">{{ $t('prospect_form.title') }}</label>
            <label v-else class="main-label">{{ $t('prospect_form.altTitle') }}</label>
            <v-form v-model="valid" class="input-container d-flex">
                <v-text-field
                        outlined
                        class="register-field name-register-field"
                        v-model="prospect.name"
                        @keypress.enter="onSendClick()"
                        :label="'* ' + $t('fields.name.label')"
                        :disabled="loading"
                        :placeholder="$t('fields.name.placeholder')"
                        :rules="rules.name"
                         append-icon="mdi-account"
                ></v-text-field>
                <v-text-field
                        outlined
                        class="register-field email-register-field"
                        type="email"
                        v-model="prospect.email"
                        @keypress.enter="onSendClick()"
                        :disabled="loading"
                        :label="'* ' +$t('fields.email.label')"
                        :placeholder="$t('fields.email.placeholder')"
                        :rules="rules.email"
                         append-icon="mdi-email"
                ></v-text-field>
                <v-text-field v-if="locale === 'pt'" type="tel"

                              required
                              outlined
                              v-mask="'(##) #####-####'" 
                              class="register-field phone-register-field"
                              v-model="prospect.phone"
                              @keypress.enter="onSendClick()"
                              :disabled="loading"
                              :rules="rules.phone"
                              :label="'* ' +$t('fields.phone.label')"
                              append-icon="mdi-phone"
                              :placeholder="$t('fields.phone.placeholder')"></v-text-field>
                <v-text-field v-else type="tel"

                              required
                              outlined
                              class="register-field phone-register-field"
                              v-model="prospect.phone"
                              @keypress.enter="onSendClick()"
                              :disabled="loading"
                              :rules="rules.phone"
                               append-icon="mdi-phone"
                              :label="'* ' +$t('fields.phone.label')"></v-text-field>
                              
            </v-form>

            <v-row no-gutters >
                <v-col class="text-legal">
                   <div class="text-justify caption"> {{ $t('legal_info') }} </div>
                </v-col>
            </v-row>

            <v-card-actions class="d-flex align-center flex-column card-actions">

                <v-row>

                    <v-col class="d-flex align-center flex-column card-actions" cols='6'>
                        <v-btn rounded color='white' to="/prospect-location" class="mb-2 mr-2 btn-register-2">
                            <v-icon small class="mr-3">mdi-arrow-left</v-icon>
                            {{ $t('back') }}
                        </v-btn>

                    </v-col>

                    <v-col class="d-flex align-center flex-column card-actions" cols='6'>
                        <v-btn rounded :disabled="!valid || loading" :loading="loading" @click="onSendClick()" class=" send-btn" color="#4ec5c1">
                            {{ $t('send') }}
                        </v-btn>
                    </v-col>          

                </v-row>

               

            </v-card-actions>

             <alert-suggestion />

        </v-card>
        
    </Modal>
</template>

<script>
import Modal from '../components/utils/Modal';
import validators from '../../utils/validators';
import { mask } from 'vue-the-mask'
import { PROSPECT_FINISHED, UPDATE_PROSPECT } from '../../store/mutations';
import { mapActions, mapGetters } from 'vuex';
import { ROUTE_SPLASH } from '../../router/routes';
import AlertSuggestion from '../components/providersList/AlertSuggestion.vue';

export default {
    name: 'ClientForm',
    directives: {
        mask
    },
    data() {
        return {
            valid: false,
            loading: false,
            locale: localStorage.locale,
            prospect: {
                name: '',
                phone: '',
                email: '',
            },
            rules: {
                name: [
                    v => validators.name.required(v) || this.$t('validators.name.required'),
                ],
                email: [
                    v => validators.required(v) || this.$t('validators.email.required'),
                    v => validators.email.invalid(v) || this.$t('validators.email.invalid'),
                ],
                phone: [
                    v => validators.required(v) || this.$t('validators.phone.required'),
                    v => validators.min_length(v) || this.$t('validators.phone.invalid'),
                ],
            },
        };
    },
    components: {
        Modal,
        AlertSuggestion,
    },
    computed: {
        ...mapGetters({ providers: 'providers', getProspect: 'ProspectVuex/prospect' })
    },

    async mounted() {

        const prospect = this.getProspect

        prospect.status = 'EnteredForm'

        await this.updateProspect(prospect)

        if (!this.providers || !this.providers.length) this.showToast(this.$t('prospect_form.toast_no_providers_msg'), this.$t('prospect_form.toast_no_providers_title'), 'info')

    },

    methods: {

        ...mapActions({ updateProspect: `ProspectVuex/${UPDATE_PROSPECT}` }),

        async onSendClick() {

            if (this.valid) {

                const loader = this.$loading.show({
                    'is-full-page': true,
                    color: 'green'
                });

                const prospect = Object.assign(this.phoneTransform(), this.getProspect)

                try {

                    await this.$store.dispatch(`ProspectVuex/${PROSPECT_FINISHED}`, prospect)

                    const msg = this.providers ?

                        {
                            title: this.$t('prospect_form.toast_send_title'),
                            body: this.$t('prospect_form.toast_send_body')
                        } : {
                            title: this.$t('prospect_form.toast_send_title_alt'),
                            body: this.$t('prospect_form.toast_send_body_alt')
                        }

                    this.showToast(msg.body, msg.title, 'info', {
                        position: "center",
                        icon: 'icon mdi mdi-email-check-outline',
                    })

                    return this.$router.push(ROUTE_SPLASH)

                } catch (error) {

                    if (error.message === 'E-mail inválido.') {

                        return this.$toast.error(error.message, this.$t('prospect_form.toast_error_title_mail'), {
                            position: "center",
                            icon: 'icon mdi mdi-email-off-outline',
                        })

                    } else {

                        return this.$toast.error(error.message, this.$t('prospect_form.toast_error_title'), {
                            position: "center",
                            icon: 'icon mdi mdi-email-off-outline',
                        })

                    }

                } finally {

                    loader.hide()

                }
            }
        },

        phoneTransform() {
            return {
                name: this.prospect.name,
                phone: this.prospect.phone.match(/\d+/g).join(''),
                email: this.prospect.email,
            }
        }
    },
}
</script>

<style scoped>

.btn-suggestion {

    margin-top: 30px !important;


}

.snack {

    width: 100px !important;

}

    .text-legal {
        margin-left: 10%;
        margin-right: 10%;
        margin-bottom: 5%;

    }

    .result-content {
        width: 90%;
        min-height: 80vh;
        max-width: 500px;
        max-height: 90%;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        border-radius: 10px
    }

    .absolute {
        position: absolute;
    }

    .main-label {
        padding: 10px;
        border-bottom: #F47E2F 1px solid;
        max-width: 80%;
        font-weight: bold;
        text-align: center;
        color: #0D2d33;
        font-size: 19px;
        line-height: 20px;
    }

    .input-container {
        width: 80%;
        max-width: 340px;
        flex-flow: column;
        margin-top: 1em;
    }

    .send-btn {
        width: 200px;
        max-width: 80%;
        margin-bottom: 1em;
    }

    @media all and (min-width: 700px) {
        .result-content {
            min-height: 50%;
            max-width: 800px;
            
        }

        .input-container {
            justify-content: space-evenly;
            max-width: unset;
        }

        .register-field {
            padding: 1em;
        }

        .main-label {
            font-size: 2em;
            line-height: 1em;
            padding-bottom: 1em;
            margin-bottom: 0.5em;
            text-align: center;
        }
    }
</style>
